import { algoliasearch } from 'algoliasearch';
import { liteClient } from 'algoliasearch/lite';

const DEFAULT_TIMEOUTS = { connect: 5000, read: 5000, write: 5000 };

/** Search-only lite client for InstantSearch / multi-query UI. */
export function createAlgoliaLiteClient(appId: string, apiKey: string) {
  return liteClient(appId, apiKey, { timeouts: DEFAULT_TIMEOUTS });
}

/** Full search client — includes `searchSingleIndex` / indexing helpers. */
export function createAlgoliaClient(appId: string, apiKey: string) {
  return algoliasearch(appId, apiKey, { timeouts: DEFAULT_TIMEOUTS });
}

/** Flatten InstantSearch / v4 `{ indexName, query, params, filters }` rows into v5 search requests. */
export function toV5SearchRequests(queries: readonly any[]) {
  return queries.map((query) => {
    const { params, ...rest } = query ?? {};
    if (params && typeof params === 'object') {
      return { ...rest, ...params };
    }
    return rest;
  });
}

export function wrapInstantSearchClient(
  client: ReturnType<typeof createAlgoliaClient> | ReturnType<typeof createAlgoliaLiteClient>,
) {
  return {
    ...client,
    search(requests: readonly any[]) {
      return client.search({ requests: toV5SearchRequests(requests) });
    },
  };
}
